import { styled } from "@mui/system";
import {
  BORDER_PRIMARY,
  BORDER_SECONDARY,
  DISPLAY_FLEX,
  FLEX_ALIGN_CENTER,
  FLEX_ALIGN_END,
  FLEX_ALIGN_START,
  FLEX_DIRECTION_COLUMN,
  FLEX_DIRECTION_ROW,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  FONT_SIZE_LG,
  FONT_SIZE_MD,
  FONT_SIZE_SM,
  FONT_WEIGHT_BOLD,
  MAX_WIDTH,
  OVERFLOW_HIDDEN,
  TEXT_ALIGN_LEFT,
  TEXT_DECORATION_NONE,
  WHITE_SPACE_NOWRAP,
} from "../../config/styles";
import { colors } from "../../config/colors";

export const LandingPageStyled = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  backgroundColor: theme.palette.secondary.contrastText,
  height: "100vh",
  width: "100vw",
  "& .welcome-page-container": {
    marginLeft: "220px",
    backgroundColor: theme.palette.secondary.contrastText,
    borderRadius: "12px 0px",
  },
  "& .welcome-page-header": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    padding: "36px 40px",
  },
  "& .migrate-page-header": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    gap: ".5rem",
    padding: "36px 40px",
    cursor: "pointer",
  },
  "& .welcome-page-search-container": {
    display: DISPLAY_FLEX,
    width: "284px",
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: FLEX_ALIGN_START,
    gap: "4px",
  },
  "& .table-footer-container": {
    marginTop: "75px",
    padding: "16px 24px 32px 24px",
  },
  " &.merchant-name-styled": {
    ...theme.typography.subtitle2,
    lineHeight: "22px",
    whiteSpace: WHITE_SPACE_NOWRAP,
    overflow: OVERFLOW_HIDDEN,
    textOverflow: "ellipsis",
    textDecoration: TEXT_DECORATION_NONE,
  },

  "& .breadcrumb-item a": {
    textDecoration: TEXT_DECORATION_NONE,
  },
  "& .migrate-page-body": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    padding: "1.5rem",
    gap: "1.5rem",
    justifyContent: FLEX_ALIGN_END,
    alignItems: FLEX_ALIGN_START,
    borderRadius: ".5rem",
    border: BORDER_SECONDARY,
    width: "520px",
    backgroundColor: theme.palette.secondary.contrastText,
  },
  "& .migrate-page-input-style": {
    width: "412px !important",
    display: DISPLAY_FLEX,
    borderRadius: "4px",
    border: BORDER_PRIMARY,
    backgroundColor: theme.palette.secondary.contrastText,
    height: "52px !important",
  },
  "& .migrate-search-button": {
    display: DISPLAY_FLEX,
    height: "52px",
    width: "52px",
    backgroundColor: theme.palette.secondary.contrastText,
    color: theme.palette.background.secondary,
    border: BORDER_PRIMARY,
    marginLeft: "12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
    },
  },
  "& .migrate-button-style": {
    display: DISPLAY_FLEX,
    width: MAX_WIDTH,
    padding: "8px 12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    gap: ".5rem",
    alignSelf: "stretch",
    borderRadius: "4px",
    backgroundColor: theme.palette.primary.main,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.secondary.contrastText,
    },
    "&:disabled": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.text.disabled,
      cursor: "not-allowed",
      border: "none",
    },
  },

  "& .migrate-seached-title": {
    width: "472px !important",
    color: theme.palette.primary.input,
    fontSize: FONT_SIZE_LG,
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: "Open Sans, sans-serif",
    lineHeight: "20px",
  },

  "& .migrate-details-item": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    flex: "33.33%",
  },
  "& .migrate-details-header": {
    fontSize: FONT_SIZE_SM,
    opacity: 0.5,
    fontFamily: "Open Sans, sans-serif",
    color: colors.nonActive,
  },
  "& .migrate-details-body": {
    fontSize: FONT_SIZE_MD,
    opacity: 1,
    fontFamily: "Open Sans, sans-serif",
    color: theme.palette.primary.input,
  },
}));

export const LandingAGgridStyled = styled("div", {
  shouldForwardProp: (prop) => prop !== "headerSelected",
})(({ theme, headerSelected }) => ({
  height: headerSelected ? "565px !important" : "586px !important",
  margin: "0 1.5rem",
  "& .ag-root-wrapper": {
    borderRadius: "0px",
  },
  "& .ag-header": {
    backgroundColor: theme.palette.background.default,
    borderBottom: BORDER_SECONDARY,
    ...theme.typography.h4,
    fontWeight: FONT_WEIGHT_BOLD,
    display: headerSelected ? "none" : DISPLAY_FLEX,
  },
  "& .ag-header-custom": {
    backgroundColor: theme.palette.background.default,
    display: headerSelected ? DISPLAY_FLEX : "none",
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    padding: "5px 24px",
    border: "1px solid #E0E0E0",
    height: "48px",
    borderLeftRadius: "8px",
    borderRightRadius: "8px",
    borderBottom: "none",
  },
  "& .ag-header-cell": {
    backgroundColor: theme.palette.background.default,
    borderRight: "none !important",
  },
  "& .ag-row": {
    borderBottom: BORDER_SECONDARY,
    alignItems: FLEX_ALIGN_CENTER,
  },
  "& .ag-cell-value": {
    ...theme.typography.subtitle2,
    textAlign: TEXT_ALIGN_LEFT,
    paddingTop: "14px",
    paddingBottom: "14px",
  },
  "& .ag-column-first": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
  },
  "& .ag-checked ": {
    backgroundColor: `${colors.primary} !important`,
    border: `1px solid ${colors.primary} !important`,
  },
  "& .ag-floating-top": {
    display: "none !important",
  },
  "& .cursor-pointer": {
    cursor: "pointer",
    userSelect: "none",
  },
  "& .ag-cell": {
    border: "none !important",
  },
  "& .ag-pinned-left-header": {
    border: "none !important",
  },
  "& .ag-pinned-right-header": {
    border: "none !important",
  },
}));
